import Slider from "react-slick";
import hero1 from "../assets/images/home/banner1.jpeg";
import hero2 from "../assets/images/home/banner2.jpeg";
import hero3 from "../assets/images/home/banner3.jpeg";

import hero4 from "../assets/images/wild.webp";
import hero5 from "../assets/images/mogali.webp";
import hero6 from "../assets/images/kashmir.webp";
import hero7 from "../assets/images/heros1.webp";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "../assets/css/HeroSection.css"; // Create this CSS file

function HeroSection() {

  function NextArrow(props) {
    const { onClick } = props;
    return (
      <div className="custom-arrow next-arrow" onClick={onClick}>
        ❯
      </div>
    );
  }

  function PrevArrow(props) {
    const { onClick } = props;
    return (
      <div className="custom-arrow prev-arrow" onClick={onClick}>
        ❮
      </div>
    );
  }

  const settings = {
    dots: true,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 4000,
    speed: 1000,
    fade: true,
    arrows: true,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />
  };

  const slides = [
    {
      img: hero1,
      title: "वाईल्डलाईफ अ‍ॅडव्हेंचर - ताडोबा व्याघ्र प्रकल्प",
      subtitle: "परीक्षा संपल्या आहेत? आता वेळ आहे पुस्तकांचे ओझे बाजूला सारून वाघांच्या राज्यात हरवून जाण्याची!"
    },
    {
      img: hero2,
      title: "ट्युलिप स्पेशल ऑफबीट काश्मीर टूर",
      subtitle: "चला अनुभवूया काश्मीरचा खरा स्वर्ग! ट्युलिपच्या रंगीबेरंगी फुलांचा उत्सव आणि गर्दीपासून दूर असलेल्या 'दुधपोखरी'चे सौंदर्य!"
    },
    {
      img: hero3,
      title: "पावन चार धाम यात्रा",
      subtitle: "​अनुभवा हिमालयाचे पावित्र्य, भक्ती आणि निसर्गाचा अनमोल संगम! यंदाची वारी, निसर्गाच्या कुशीत... 'तीर्थसारथी'सोबत! आम्ही घेऊन आलो आहोत एक अशी आध्यात्मिक यात्रा."
    },
  ];

  return (
    <div className="hero-slider">
      <Slider {...settings}>
        {slides.map((slide, index) => (
          <div key={index}>
            <div
              className="hero-slide"
              style={{ backgroundImage: `url(${slide.img})` }}
            >
              <div className="hero-overlay"></div>
              <div className="container">
                <div className="row align-items-center hero-height">
                  <div className="col-md-8 col-lg-7 text-white hero-text">
                    <h1 className="hero-title">{slide.title}</h1>
                    <p className="hero-subtitle">{slide.subtitle}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))}
      </Slider>
    </div>
  );
}

export default HeroSection;